"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background px-4">
      <div className="text-center">
        <div className="text-5xl mb-4">⚠️</div>
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          出现错误
        </h2>
        <p className="text-muted-foreground mb-6 max-w-md">
          {error.message || "抱歉，发生了意外错误"}
        </p>
        <button
          onClick={reset}
          className="inline-flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-white font-medium transition-colors hover:bg-blue-700"
        >
          重试
        </button>
      </div>
    </div>
  );
}
